import { EditBusinessHeaderOption, EditBusinessMode, EditBusinessModeConfig } from './pages/useEditBusinessStore/types';

export const DEFAULT_WIDTH = { str: 200, num: 80, date: 120 };

export const AGGREGATE_BUSINESS_HEADER_OPTIONS = [
  { key: 'checkbox', label: '', width: 48, type: 'uni' },
  { key: 'warehouseNumber', label: '置場CD', type: 'str' },
  { key: 'warehouse', label: '置場名', type: 'str' },
  { key: 'supplierNumber', label: '仕入先CD', type: 'str' },
  { key: 'supplierName', label: '仕入先名', type: 'str' },
  { key: 'businessNumber', label: '商品CD', type: 'str' },
  { key: 'businessName', label: '商品名', type: 'str' },
  { key: 'package', label: '容量', type: 'num' },
  { key: 'unit', label: '単位', type: 'str' },
  { key: 'manufacturer', label: '製造社', type: 'str' },
  { key: 'purchaseUnitPrice', label: '仕入単価', type: 'num' },
  { key: 'leadTime', label: 'リードタイム', type: 'str' },
  { key: 'stdInvIndex', label: '標準在庫指数', type: 'str' },
  { key: 'MOQ', label: 'MOQ', type: 'num' },
  { key: 'orderPackage', label: '発注単位', type: 'num' },
  { key: 'aggregateBusinessResponsibleUser', label: '仕入担当者', type: 'str' },
  { key: 'userUniqueNumber', label: 'ユーザー固有番号', type: 'str' },
  { key: 'note', label: 'メモ', type: 'str' },
  { key: 'createdAt', label: '作成日時', type: 'date' },
  { key: 'updatedAt', label: '更新日時', type: 'date' },
  { key: 'headerModify', label: 'ヘッダー編集', width: 57, type: 'uni' },
] as const satisfies EditBusinessHeaderOption[];

export const BASE_BUSINESS_HEADER_OPTIONS = [
  { key: 'checkbox', label: '', width: 48, type: 'uni' },
  { key: 'customerNumber', label: '売上先CD', type: 'str' },
  { key: 'customerName', label: '売上先名', type: 'str' },
  { key: 'salesDestinationNumber', label: '送り先CD', type: 'str' },
  { key: 'salesDestinationName', label: '送り先名', type: 'str' },
  { key: 'endUser', label: 'エンドユーザー', type: 'str' },
  { key: 'salesUnitPrice', label: '販売単価', type: 'num' },
  { key: 'baseBusinessResponsibleUser', label: '販売担当者', type: 'str' },
  { key: 'warehouseNumber', label: '置場CD', type: 'str' },
  { key: 'warehouse', label: '置場名', type: 'str' },
  { key: 'supplierNumber', label: '仕入先CD', type: 'str' },
  { key: 'supplierName', label: '仕入先名', type: 'str' },
  { key: 'businessNumber', label: '商品CD', type: 'str' },
  { key: 'businessName', label: '商品名', type: 'str' },
  { key: 'package', label: '容量', type: 'num' },
  { key: 'note', label: 'メモ', type: 'str' },
  { key: 'createdAt', label: '作成日時', type: 'date' },
  { key: 'updatedAt', label: '更新日時', type: 'date' },
  { key: 'headerModify', label: 'ヘッダー編集', width: 57, type: 'uni' },
] as const satisfies EditBusinessHeaderOption[];

export const MODE_CONFIG: Record<EditBusinessMode, EditBusinessModeConfig> = {
  aggregateBusiness: {
    headerOptions: AGGREGATE_BUSINESS_HEADER_OPTIONS,
    tableType: { bulk: 'bulkEditAggregateBusiness', master: 'editMasterAggregateBusiness' },
  },
  baseBusiness: {
    headerOptions: BASE_BUSINESS_HEADER_OPTIONS,
    tableType: { bulk: 'bulkEditBaseBusiness', master: 'editMasterBaseBusiness' },
  },
};

export const AggregateBusinessNullableFormItem = [
  'unit',
  'manufacturer',
  'userUniqueNumber',
  'MOQ',
  'orderPackage',
  'purchaseUnitPrice',
  'aggregateBusinessResponsibleUser',
] as const;
/**
 * nullにできるテキストフォームのoption名タイプ
 */
export type AggregateBusinessNullableForm = (typeof AggregateBusinessNullableFormItem)[number];

/**
 * nullにできるテキストフォームのState
 */
export type AggregateBusinessNullableFormState = Record<AggregateBusinessNullableForm, boolean>;

export const AGGREGATE_BUSINESS_NULLABLE_FORM_DEFAULT_STATE: AggregateBusinessNullableFormState = {
  unit: false,
  manufacturer: false,
  userUniqueNumber: false,
  MOQ: false,
  orderPackage: false,
  purchaseUnitPrice: false,
  aggregateBusinessResponsibleUser: false,
};

export const BaseBusinessNullableFormItem = ['endUser', 'salesUnitPrice', 'baseBusinessResponsibleUser'] as const;
/**
 * nullにできるテキストフォームのoption名タイプ
 */
export type BaseBusinessNullableForm = (typeof BaseBusinessNullableFormItem)[number];

/**
 * nullにできるテキストフォームのState
 */
export type BaseBusinessNullableFormState = Record<BaseBusinessNullableForm, boolean>;

export const BASE_BUSINESS_NULLABLE_FORM_DEFAULT_STATE: BaseBusinessNullableFormState = {
  endUser: false,
  salesUnitPrice: false,
  baseBusinessResponsibleUser: false,
};

export const TargetMasterItems = ['warehouse', 'supplier', 'business', 'customer', 'salesDestination'] as const;
